import { render, staticRenderFns } from "./EnableTransaction.vue?vue&type=template&id=58d05360&scoped=true&"
import script from "./EnableTransaction.vue?vue&type=script&lang=ts&"
export * from "./EnableTransaction.vue?vue&type=script&lang=ts&"
import style0 from "./EnableTransaction.vue?vue&type=style&index=0&id=58d05360&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d05360",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VDialog,VIcon,VTextField})
